module.exports = {
  // 发现页
  find: {
    str1: "资讯",
    str2: "查看更多 >",
    str3: "经常做运动有必要监测一下血氧吗？",
    str4: "你的血氧含量正常吗？",
    str5: ["健康", "运动"],
    str6: "人浏览",
    str7: "控制静息心率对于冠心病的重要性。",
    str8: "这点你知道吗？",
    str9: "关于运动心率区间。",
    str10: "你真的了解运动心率区间吗？",
    str11: "比癌症更可怕的是高血压。",
    str12: "高血压怎样伤害身体？",
    str13: "血糖偏高怎么办？",
    str14: "血糖在什么范围内才算正常？",
    str15: "只有胖人才会得高血脂吗？",
    str16: "高血脂的5个误区。",

    str17:
      "“血氧含量是指血液中的含氧总量，包括血液中物理溶解的氧和与血红蛋白结合的氧。”人体吸入肺部的氧气，最终会与红细胞中的血红蛋白结合，然后被分配到身体的各个器官、组织中，只有这样细胞才能生存下来，正常工作。",
    str18:
      "但是，并非每个血红蛋白都会被选中，没有发生结合的血红蛋白就落单了。和氧气组成CP的血红蛋白÷（CP数+落单血红蛋白数）的值就是血氧饱和度，简单来说，它用来衡量携带氧气的红细胞比例。",
    str19: "那么血氧饱和度多少是正常呢？",
    str20:
      "大多数时候，每个血红蛋白都能找到自己的氧气伴侣，健康人的血氧饱和度保持在95-100%之间是正常的。",
    str21:
      "明白了血氧含量的概念之后，下一个问题是，血氧含量的高低对人体有哪些影响？",
    str22:
      "因为人体内所有细胞都依赖氧气为生，血氧含量几乎会影响到身体的每一个部分。血氧饱和度低会出现全身的严重并发症，例如神经系统缺氧会导致头痛头晕、暴躁易怒、神智障碍以至于昏迷；心血管系统缺氧会导致心肌缺血，严重的会出现心脏骤停，心力衰竭；呼吸系统缺氧会导致呼吸衰竭，呼吸停止等。",
    str23:
      "在国内运动型猝死的研究报道中，有部分病例表明运动者心脏没有发生器质性病变和异常，死因可能是运动负荷超出其承受范围，心脏循环系统需要的血液量和需氧量突增，而供给量却相对减少。在这种血氧供不应求的状态下，运动者的心肌会出现急性缺血、心脏停搏和脑血中断，进而发生运动性心脏猝死和脑性猝死。",
    str24:
      "普通人要使血氧含量保持在正常水平，一是保持空气新鲜、流通，二是加强心肺功能锻炼，增强呼吸能力和血液运输能力。规律的运动，尤其是有氧运动，能有效提升呼吸系统的功能，在一定程度上提高抵抗疾病的能力。因此，提倡大家保持规律运动，尤其是有氧运动。",
    str25:
      "而对于平时运动较少，突然运动量增加，或者运动缺乏专业指导的普通人，有条件可以做一下血氧检测。",
    str26:
      "出于生活便利的需求，目前已有“血氧手表”等可穿戴家用检测设备，帮助人们足不出户检测血氧饱和度。",

    str27:
      "董女士冠心病已经3年了，最近又因为疾病复发来医院了，医生给她做了一些基础检查，血压、血脂、血糖控制的都挺好，可一看心率88次/分钟，有些不对劲，就问董女士，给她开的倍他乐克有没有按时吃，董女士的回答让医生找到了她复发的原因。",
    str28:
      "董女士在1年前就已经停用了倍他乐克，因为她看了药物说明书看见了“降血压”几个字，就判断倍他乐克是降压药，她同时还在吃着“沙坦”这种降压药，就想着两种降压药减一种，如果血压也能控制好，不是就能少吃药还治病吗！就是用这样的小聪明，停服了倍他乐克1年多，血压是没什么问题，但是冠心病却复发了。",
    str29:
      "董女士疾病的复发表面上看来是自己自行停药，而造成的问题，其实本质上是很多患者都不了解的“控制静息心率对于冠心病的重要性”。",
    str30: "什么是静息心率？",
    str31:
      "静息心率是指在清醒、不活动的安静状态下每分钟心跳的次数，是生理检查的一项重要指标，常作为评估心血管系统健康的标准之一。",
    str32: "静息心率对冠心病患者来说意味着什么？",
    str33:
      "临床已经证实静息心率增快是冠心病发病与死亡的一项独立危险因子。静息心率与冠心病发病危险因素例如高血压、高纤维蛋白原血症、高甘油三酯血症和高血糖聚集性均有关联，总的来说，静息心率过快易发冠心病。所以，控制好静息心率是可以降低冠心病发病率的。",
    str34: "有什么控制静息心率的好方法吗？",
    str35:
      "比较直接的方式是药物控制心率。临床普遍认为，非二氨吡嘧类钙拮抗剂（异博定、地尔硫卓）、β阻滞剂（氨酰心安、美多心安、倍他乐克）和地高辛可以有效地控制静息心率，应用方面因为要考虑患者的耐受性，常常需要根据情况改换以及联合用药。",
    str36:
      "有心血管疾病病史的朋友还要注意在日常生活中保持良好的心理状态。别激动，别发火，减少情绪的大起大落。",
    str37: "忌烟忌酒。抽烟和饮酒都会使交感神经兴奋，从而加快心率。",
    str38: "冠心病患者清晨5分钟自测静息心率",
    str39:
      "要测得相对准确的静息心率其实很简单，只需利用每天起床的5分钟就能完成：",
    str40: "1、起床后静坐3-4分钟，让身体和精神都保持在平静状态。",
    str41:
      "2、可以利用带心率监测功能的手表、手环、心电监测仪，或直接用手号脉，选择腕部或颈部脉波搏动部位，监测1分钟，可以得到自己的静息心率。",
    str42:
      "3、睡眠不足、饮酒、咖啡、浓茶等会对心率产生影响，需要监测静息心率的人群时尽量避免上述因素。",
    str43:
      "对于有心血管病的患者，建议将清晨刚醒未起时心率控制在50~60次/分（或 55~60次/分）比较合适，如果日常休息态，建议心率控制在70次/分以下，对于活动状态下，建议心率增加小于20次/分为佳，同时结合自身的实际，以不出现自身不适为准，有条件者可在医生指导下行相关活动。对于房颤病人建议心率控制在110次/分以下。",
    str44:
      "有心血管疾病的患者们，如果您之前没有足够重视自己的心率，那么从看完这篇文章开始，每天花费5分钟，测测自己的心率，高了低了一目了然，心率跟血压、血脂、血糖一样重要。",

    str45:
      "静息心率（Rest Heart Rate，简写RHR）和 最大心率（Max Heart Rate，简写MHR）是决定个人训练区间最重要的两个参数。静息心率是指安静状态下的心跳频率。安静状态下，成人正常心率为60～100次/分钟，理想心率应为55～70次/分钟（运动员的心率较普通成人偏慢，一般为50次/分钟左右）。 最大心率值最常用计算方法是用220减去你的年龄从而得到你的最大心跳频率，例如：一个32岁的人的最大心跳频率为188跳每分钟，即MHR=220-年龄。正确了解跑步时的平均心率对于人体健康水平的影响，都将有助于你获得更加理想高效的锻炼结果。",
    str46:
      "最常使用的是从50%到100%最大心率划分成5个区间，由低到高运动强度逐渐增大，训练效果也随之变化。",
    str47: "灰色区间1：热身恢复锻炼，50-60%MHR。",
    str48:
      "轻度运动，耗能极少，用于跑步前的动态热身，跑步后的放松活动，也是人体感觉最舒适的心率区间，可以轻松通过散步或慢走达到。在此区间的活动对于降低血压，提升心血管健康以及减脂方面会有一定的帮助，但是效率很低。",
    str49: "蓝色区间2：燃脂耐力锻炼，60%-70%MHR。",
    str50:
      "身体以脂肪代谢为主。适合以放松恢复为目的 慢跑和椭圆机、健身操等轻松锻炼项目，也可通过快走/慢跑/热身运动进入此区间，在此区间保持一段时间可以让身体准备好增强脂肪代谢，接受高强度运动。",
    str51: "绿色区间3：有氧心肺锻炼，70%-80%MHR。",
    str52:
      "中到高度有氧区间，糖原代谢比例增大，有效锻炼有氧能力，提高脂肪利用率。强度适中，适合 健身减肥为目的跑步者， 马拉松选手的大部分训练应该在这一区间，处于一般人正常运动强度，可通过持续慢跑进入此区间。此区间内的运动，对于心血管和呼吸系统的健康程度提升明显，此外，卡路里消耗和燃脂水平也较为均衡，每60分钟的训练，达成20-30分钟在此区域则比较理想。",
    str53: "橙色区间4：肌力强化锻炼，80%-90%MHR。",
    str54:
      "乳酸阈值区间，糖原代谢为主，出现乳酸堆积。强度较大。节奏跑（tempo）和马拉松配速跑在这一区间。可以通过高强度运动进入此区间，此时身体会感觉较为不适，但这一区域对于HIIT/EPOC训练法来说是最重要的：训练中，新陈代谢水平高，脂肪代谢非常明显；训练后，由于机体需要代谢EPOC产生的乳酸，也会保持长时间的热量消耗。 每60分钟的训练，达成10-20分钟在此区域则比较理想。用于训练身体提高乳酸耐受性， 每周训练不应超过1.5小时。",
    str55: "红色区间5 : （力竭等级）无氧极限锻炼90%-100%MHR。",
    str56:
      "接近无氧代谢，几乎全部能量来源于糖原分解。心脏负担很大，锻炼绝对速度能力， 适合有经验的跑步者，从运动效果方面来讲，此区间的代谢水平最高，但是运动过程中进入此区间并不是必要的，而且是不推荐的。如果进入了此区间，请逐渐降低运动强度，并将每次的持续时间控制在3mi-5min以内，从而控制运动风险。",

    str57:
      "人人谈癌色变，但其实杀死中国人的头号杀手，不是癌症而是心血管病。而心血管病死亡里头号致死因素是常见的高血压。",
    str58:
      "高血压是指以体循环动脉血压（收缩压和/或舒张压）增高为主要特征，可伴有心、脑、肾等器官的功能或器质性损害的临床综合征。流行病学调查显示，我国已有2.7亿人群患有高血压，成为了威胁中国居民健康的主要慢性病之一。致死率高但人群知晓率低，高血压可谓是名副其实的“隐形杀手”了，更可怕的是它会引发各种致命的高血压并发症。",
    str59: "高血压怎样伤害身体?",
    str60:
      "在“三高”、吸烟、肥胖等因素的共同作用下，不可逆转的损伤持续积累，加重影响全身血液供应，逐渐造成器官组织结构改变甚至危及生命。",
    str61: "心脏",
    str62:
      "心脏是推动全身血液循环的“血泵”。一方面血压升高，血管变细，阻力变大，给心脏带来了额外的工作负担。心脏为了工作需要变得肥大，出现左心室肥厚；但随着高血压进展，心脏最终仍然不堪重负，出现心力衰竭，导致死亡。另一方面，高血压促进冠状动脉粥样硬化，冠状动脉变窄或阻塞，造成心肌缺血、缺氧或坏死，就是俗称的冠心病；心肌缺血也可引发心律失常。心律失常和急性心肌梗死发作可直接导致猝死，也会引起和加速心力衰竭，最终死亡。临床数据显示，收缩压每升高10mmHg，缺血性心脏病风险升高31%。",
    str63: "脑",
    str64:
      "高血压同样会损伤脑血管。如果脑血管突然破裂出血，或者脑血管阻塞导致血液不能流入，会使脑组织产生损伤，导致脑梗死，就是俗称的“中风”。脑梗死引发的脑组织损伤可能是暂时的，也可能是永久的。根据脑组织损伤发生的部位不同，患者的结局也不同：直接死亡、肢体偏瘫、失明、失语、失忆、读写困难、吞咽困难、行走障碍等，受脑部支配的一切功能都有可能发生障碍，或者彻底丧失。",
    str65:
      "高血压患者发生脑梗死的危险性是正常人的4到6倍。80%的脑梗死与高血压有关，其致死率是50%~60%，致残率是75%。",
    str66: "肾",
    str67:
      "肾脏是血液系统的过滤器，通过调节排出身体的水量和物质，可以起到调节血压、代谢有害物质的作用。肾脏内部密集的小血管网很容易被高血压损伤，一旦肾功能下降，肾脏调节血压的功能受损，就会进一步使血压升高，进入恶性循环，最终发展为肾功能衰竭也就是尿毒症，有害物质和多余的液体在人体堆积，不得不靠持续透析延续生命，直至死亡。",
    str68: "生殖系统",
    str69:
      "高血压引起血管狭窄或堵塞，性器官供血不足，会导致性功能障碍。在男性中，主要表现为勃起功能障碍；在女性中，主要表现为性欲减退、阴道干涩、无法高潮，影响患者性生活的满意度。妊娠高血压严重影响母婴健康，是孕产妇和围生儿发病和死亡的主要原因之一。怀孕期间，因为母亲要负担自身和胎儿两者的血液供应，因此孕期高血压会对母亲和胎儿都产生不良影响。对于胎儿，妊娠高血压可导致胎盘血流不足，胎儿吸收不到足够的营养和氧气，因而出现早产、胎儿宫内窘迫及死亡、胎儿宫内生长迟缓、死产、新生儿窒息死亡等情况。对于母亲，可引起胎盘早期剥离、心力衰竭、凝血功能障碍、脑出血、肾功能衰竭及产后血液循环障碍等致命情况。孕妇高血压病情越重，对胎儿的不良影响越大。此外，高血压还可引起钙质流失，导致骨质疏松、骨折；或引起周围血管病，导致抽筋、跛行、消化不良等。",
    str70: "监测血压",
    str71:
      "因为高血压风险高损害大，所以越早确诊越早治疗越好；但高血压早期往往没有明显症状，因此能尽早确诊高血压的唯一手段，就是到正规医疗机构，由专业人士进行标准的血压测量。",
    str72:
      "对于已经确诊的高血压患者，坚持规律自测血压也同样重要，不能仅凭主观症状和感受来判断病情。",
    str73:
      "高血压病人的血管弹性差，同样的血压变化，高血压患者的血管比正常人更容易堵塞或破裂，引起急性致命的不良心血管事件（比如脑梗死、心肌梗死等）。",
    str74: "稳定的血压数值，对于延长高血压患者的寿命至关重要。",
    str75: "改善生活方式",
    str76:
      "随着年纪的增长血压升高是正常现象但实际上高血压的成因十分复杂和遗传、饮食、不健康的生活习惯等都有关系那么应该如何正确应对高血压呢？最主要的还是早期预防和治疗。高血压患者应在饮食和生活习惯上注意以下几点：",
    str77: "1、合理饮食，尤其注意低钠",
    str78:
      "应遵循低盐、低脂、低热量原则，并注意饮食结构合理搭配，多吃蔬菜水果。少吃腌制的肉类、蔬菜。少用高钠的调料，比如酱油、蚝油、沙拉酱、番茄酱、汤料包；多用天然调味料，如葱、姜、蒜、胡椒、柠檬等。",
    str79: "2、戒烟",
    str80:
      "香烟中的尼古丁会让中枢神经和交感神经兴奋，使心率加快，促使肾上腺释放大量儿茶酚胺，使心跳更快，收缩压和舒张压都会升高。",
    str81: "3、限酒或戒酒",
    str82:
      "大量数据表明，饮酒量与血压水平呈正性线性相关。尤其是中年人，更应该适量饮酒，最好是戒酒，因为饮酒对身体毫无益处。",
    str83: "4、坚持运动",
    str84:
      "早在1988年，美国高血压联合会议正式确立了运动疗法为高血压综合治疗的方法之一。每周至少五天，进行30分钟左右的有氧运动，如步行、慢跑、打太极拳等，运动以中低强度为宜。但是，重度高血压患者或者有心衰等并发症的人群，最好先控制病情，不要着急运动。",
    str85: "5、减体重",
    str86:
      "肥胖是高血压的危险因素之一，研究发现超过正常体重25公斤的肥胖者，其收缩压可高于正常人1.33千帕（10mmHg），舒张压高0.93千帕（7mmHg）。体重每减5公斤血压可下降10~20mmHg",
    str87: "6、缓解压力、情绪稳定",
    str88:
      "工作、生活中压力比较大、精神比较紧张的情况下，身体会分泌儿茶酚胺，引起血管收缩，造成排血时阻力加大，易引起血压升高。所以要学会自我缓解压力。高血压病人应该避免情绪激动及过度紧张、焦虑，避免发脾气，维持情绪稳定，保持良好心情。",
    str89:
      "以上说的都是日常生活中的注意事项都是最基本的要求能做到的话对控制血压有莫大的好处",
    str90: "控制血压最重要的还是",
    str91: "7、坚持用药",
    str92:
      "只有合理用药，才能有效减少心脑血管意外，防止高血压、肾病等并发症的发生。此外，服药期间切勿自行断药、换药或减药，应定期复查，根据医生建议调整用药。",
    str93: "还要记住，每天都应该监测血压。",

    str94:
      "糖尿病也是威胁人们生命健康的一大疾病之一，目前我国患上糖尿病的人数已经高达1亿多，中年以后越来越多的人都被糖尿病缠上。",
    str95:
      "得了糖尿病之后，就需要长期服用药物或者注射胰岛素来稳定血糖，还有一些老人，虽然没有得糖尿病，但是也比较关注自己的血糖变化，就害怕自己也被糖尿病盯上，因此也会定期去医院或药店测血糖。",
    str96:
      "那么对于正常人来说，血糖在什么范围内才算正常？国家规定的血糖标准当中显示正常的血糖值是要保持在空腹状态之下健康人群的血糖值普遍在4.4~7.0mmol/L左右。",
    str97:
      "当然即便是出现了血糖偏高的情况也不要担心，首先要做的是积极寻求医生的帮助，并且积极配合医生的治疗，将血糖控制在合理范围之内，如果前期就出现了血糖偏高的情况，进行积极控制的话，也有可能会发生逆转。",
    str98: "血糖偏高的人，除了依靠药物，生活调理也很关键，医生提出了以下几点：",
    str99: "1、饮食干预",
    str100:
      "首先要改掉自己的饮食习惯，做好饮食结构调整，饮食干预对于血糖稳定是很关键的，除了少吃高糖食物以外，对于高碳水高脂肪高热量食物也要少吃，这种食物会降低自身代谢，不利于血糖稳定。",
    str101: "2、运动干预",
    str102:
      "血糖偏高之后的，平时也要加强运动量，多运动能够提高新陈代谢，加速血液循环，提高胰岛素的敏感性，更有利于稳定血糖。",
    str103: "3、多喝水",
    str104:
      "多喝水能够稀释血液浓度，而且还能提高新陈代谢，加速血液循环，更有利于血糖的稳定。",
    str105: "怎么才能使血糖更准确？",
    str106:
      "因为影响血糖的因素有很多，为了保证数值更加准确，建议大家测量血糖时一定要空腹测量，而且也要保证平和的心态，不要太过紧张。",

    str107:
      "有调查结果显示，中国成人血脂异常高达40.4%，也就是说平均每10个成年人就有4个高血脂。大家都知道血脂太高了不好，体检时发现血脂高、胆固醇高，就开始慌了。",
    str108:
      "为什么瘦的人也会高血脂？如何了解自己的血脂水平？是不是不能吃油、不能吃鸡蛋？",
    str109: "高血脂——危险的血管炸弹",
    str110:
      "我们说的高血脂，指的是血脂异常。也就是下面4个血脂检查指标中，出现任意一项都是高血脂——",
    str111: "TC总胆固醇→高了",
    str112: "TG甘油三酯→高了",
    str113: "LDL-C低密度脂蛋白胆固醇（坏胆固醇）→高了",
    str114: "HDL-C高密度脂蛋白胆固醇（好胆固醇）→低了",
    str115:
      "通常来说，「高血脂」本身不会造成明显症状。但如果血管中粘附的脂质越多、管腔越狭窄，就会容易导致冠状动脉粥样硬化斑块的形成，出现冠心病、心梗、脑梗等，严重会危及生命的。",
    str116: "高血脂的5个误区",
    str117: "1、只有胖人才会得高血脂？",
    str118:
      "通常，高血脂多发生于肥胖及中老年群体，但并不是胖人的专属。血脂是否会偏高，并不单纯是因为摄入脂肪过多引起的。生活方式、遗传因素、疾病、药物均可能导致高血脂。所以会看到，很多体型苗条的人也会得高血脂。",
    str119: "2、高血脂不能吃鸡蛋？",
    str120:
      "蛋黄的胆固醇含量较高，高血脂患者会担心吃鸡蛋加重病情。但其实只要不吃太多，每天吃一个，完全没问题。血脂中的胆固醇大部分来源于内源性生成，即使食物中含有较多胆固醇，对于胆固醇的平衡影响也不大。",
    str121: "3、喝醋可以降血脂？",
    str122:
      "这种说法并没有什么科学依据，醋不可能直接到达血管里，更谈不上软化血管、降血脂。大量喝醋，由于醋酸的刺激性，还会损伤胃粘膜，到时候后悔都来不及了。",
    str123: "4、血脂水平正常了，就不用吃药了吗？",
    str124:
      "如果只靠药物来改善血脂水平，立即停药有一定风险。最好在用药的同时结合生活方式的调节。血脂水平稳定后，在医生的指导下，进行下一步操作，但绝不能自己随意减药或者停药。",
    str125: "5、血脂高就不能吃肉、吃油？",
    str126:
      "肉类和油类都含有身体必需的营养物质。吃素食，虽然可能会改善血脂异常，但长期下去，容易出现营养不良。",
    str127: "控血脂，做到这3点",
    str128: "血脂和生活方式关系密切，好的生活方式是改善高血脂的基础。",
    str129: "1、定期查血脂",
    str130: "20～40岁，至少 5 年测量 1 次；",
    str131: "40 岁以上男性和绝经期后女性，每年检测 1 次；",
    str132: "高血压、糖尿病、肥胖、吸烟的人，每 3～6 个月检查 1 次；",
    str133: "2、控制饮食，少吃饱和脂肪",
    str134:
      "饱和脂肪就是我们所说的「坏脂肪」，如果摄入过多会增加体内胆固醇含量。少吃饱和脂肪，可以这样做：",
    str135: "植物油（椰子油、棕榈油除外）代替动物油；",
    str136: "少吃猪肉、牛肉等红肉，多吃鸡肉、鱼肉等白肉，吃肉时把皮去掉；",
    str137: "少吃油炸食品、糕点；",
    str138: "脱脂牛奶代替全脂牛奶；",
    str139: "3、多运动",
    str140:
      "坚持每周 5 天，每天 30 分钟的中等强度运动，有助于控制血脂。 可以根据自身爱好，选择适合自己的运动，比如：慢跑、快步走、游泳、广场舞、打太极都可以。如果血脂高到了要吃药的地步，一定要按时吃药，定期检查。",

    activity1: "活动",
    activity2: "全部",
    activity3: "创建",
    activity4: "我的",
    activity5: "进行中",
    activity6: "暂无进行中活动",
    activity7: "已结束",
    activity8: "暂无已结束活动",
    activity9: "请添加活动海报",
    activity10: "请输入活动名称",
    activity11: "类型",
    activity12: "请选择活动类型",
    activity13: ["骑行", "跑步", "徒步"],
    activity14: "取消",
    activity15: "确定",
    activity16: "开始时间",
    activity17: "请选择开始时间",
    activity18: "结束时间",
    activity19: "请选择结束时间",
    activity20: "报名截止时间",
    activity21: "请选择截止时间",
    activity22: "活动地点",
    activity23: "请填写活动地址",
    activity24: "下一步",
    activity25: "开始时间/结束时间/报名时间关系错误",
    activity26: "姓名",
    activity27: "请输入真实姓名",
    activity28: "手机号码",
    activity29: "请输入手机号码",
    activity30: "人数限定",
    activity31: "不限定",
    activity32: "自定义输入",
    activity33: "活动描述",
    activity34: "请输入活动描述",
    activity35: "上一步",
    activity36: "完成",
    activity37: "创建中...",
    activity38: "我参与的活动",
    activity39: "暂无参加的活动",
    activity40: "我创建的活动",
    activity41: "暂无创建的活动",
    activity42: "请上传图片格式",
    activity43: "上传中...",
    activity44: "人报名",
    activity45: "跑步活动",
    activity46: "骑行活动",
    activity47: "徒步活动",
    activity48: "年",
    activity49: "月",
    activity50: "日",
    activity51: "时",
    activity52: "分",

    foot1: "好物推荐",
    foot2: "1963YH智能手表",
    foot3: "运动、体温、心率、血氧",
    foot4: "J-style红外线额温计",
    foot5: "非接触式、一秒测温"
  },

  // 一体机
  machine: {
    index1: "Youhong Multifunction Analyzer",
    index2: "Disconnect",
    index3: "Share",
    index4: "Reconnect",
    index5: "Connected",
    index6: "Last Measurement ",
    index7: [" AM", " PM"],
    index8: "Reference >",
    index9: "BP & HR",
    index10: "Blood Pressure",
    index11: "Heart Rate",
    index12: "Blood Lipids",
    index13: "Total Cholesterol",
    index14: "Triglycerides",
    index15: "LDL Cholesterol",
    index16: "HDL Cholesterol",
    index17: "Blood Glucose",
    index18: "FBG",
    index19: "PBG",
    index20: "Uric Acid",
    index21: "Health Records",
    index22: "Settings",

    range1: "BP Reference",
    range2: ["SBP", "DBP"],
    range3: "Rest heart Rate Reference",
    range4: "Total Cholesterol Reference",
    range5: "Triglyceride Reference",
    range6: "LDL Cholesterol Reference",
    range7: "HDL Cholesterol Reference",
    range8: "(Main Risk Factors for Coronary Cardiovascular Disease)",
    range9: "Blood Glucose Reference",
    range10: "Fasting before Meals",
    range11: "2H After Meals",
    range12: "Uric Acid Reference",
    range13: ["male", "female"],
    range14: [
      "Critical",
      "Normal",
      "Normal (Good)",
      "Normal (Best)",
      "Abnormal (Low)",
      "Abnormal (High)",
      "Abnormal (Super High)"
    ],

    pressure1:
      "The measurement data is for reference only. Please consult doctors first before using as diagnosis and medication guidance.",
    pressure2:
      "When the blood flows in the blood vessel, it acts on the side pressure of the blood vessel wall per unit area, which is the driving force for the blood to flow in the blood vessel. In different blood vessels, they are called arterial blood pressure, capillary blood pressure and venous blood pressure. Generally speaking, blood pressure refers to the arterial blood pressure of systemic circulation.",
    pressure3:
      "The number of heartbeats per minute of a normal person in a quiet state, also called the resting heart rate, is generally 60 to 100 beats per minute. Individual differences can occur due to age, gender, or other physiological factors. Generally speaking, the younger the age, the faster the heart rate, the heart rate of the elderly is slower than that of the young, and the heart rate of women is faster than that of men of the same age. These are normal physiological phenomena. In a quiet state, the normal heart rate of adults is 60-100 beats/minute, and the ideal heart rate should be 55-70 beats/minute (the athlete’s heart rate is slower than that of ordinary adults, generally about 50 beats/minute).",

    fat1:
      "The general term for neutral fats (triglycerides) and lipids (phospholipids, glycolipids, sterols, steroids) in plasma are widely present in the human body. They are essential substances for the basic metabolism of living cells. All blood lipids are combined with proteins to form lipoproteins. The basic structure of lipoprotein is the core of different content of triglycerides, surrounded by a layer of phospholipids, cholesterol and protein molecules. Lipoproteins are classified according to their density: chylomicrons CM, very low density lipoprotein VLDL, low density lipoprotein LDL, and high density lipoprotein HDL. Among them, the main carriers of triglycerides are chylomicrons and very low-density lipoproteins, and the main carriers of cholesterol are low-density lipoproteins and high-density lipoproteins.",
    fat2: "Blood Lipids",
    fat3: "Blood Lipids Reference",

    sugar1:
      "Glucose is an important component of the human body and an important source of energy. The normal human body needs a lot of sugar every day to provide energy and power for the normal operation of various tissues and organs. Therefore, blood sugar must be maintained at a certain level in order to maintain the needs of various organs and tissues in the body. The production and utilization of blood sugar in normal people is in a state of dynamic equilibrium and maintained at a relatively stable level. This is due to the fact that the source and the way of blood sugar are roughly the same.",
    sugar2: "The sources of blood sugar include:",
    sugar3: "① Food digestion and absorption;",
    sugar4: "② Decomposition of glycogen stored in the liver;",
    sugar5: "③ Conversion of fat and protein;",
    sugar6: "The path to blood sugar includes:",
    sugar7: "① Oxidation is transformed into energy;",
    sugar8:
      "② It is converted into glycogen and stored in the liver, kidneys and muscles;",
    sugar9:
      "③ It is converted into fat and protein and other nutrients to be stored. The pancreatic islets are the main organs in the body that regulate the blood glucose concentration of blood sugar, and the liver stores hepatic glycogen. In addition, blood glucose concentration is also regulated by nerves and secreted hormones;",

    ua1:
      "Under normal circumstances, there are about 1200 mg of uric acid in the body, about 600 mg is newly produced every day, and 600 mg is excreted at the same time, in a balanced state. However, if the body produces too much to be excreted or the uric acid excretion mechanism is degraded, there will be too much uric acid in the body. When the blood uric acid concentration is greater than 7 mg/dL, the body fluid will become acidic and affect the normal function of human cells. Long-term neglect will cause gout. In addition, too much fatigue or lack of rest can also lead to relatively slow metabolism and lead to the onset of gout.",
    ua2:
      "All blood uric acid is filtered from the glomerulus, 98% of which is secreted into the glomerular lumen in the middle of the proximal convoluted tubule, and then 50% of the reabsorbed uric acid is secreted into the lumen of the renal tubule in the middle of the proximal convoluted tubule. In the straight section of the proximal convoluted tubule, 40%～44% is reabsorbed, and only 6%～10% uric acid is excreted. The production and excretion rate of uric acid in normal human body is basically constant. Changes in the content of uric acid in body fluids can fully reflect the status of metabolism, immunity and other functions in the body.",

    setUp1: "Others",
    setUp2: "How to Use",
    setUp3: "FAQ",

    method1: "Power ON/OFF",
    method2:
      'Long press the "0" button to turn on, and please make sure that the device is fully charged before power on.',
    method3: "Parameter Settings",
    method4:
      'Press "0", "<", ">" to set the time, unit, sample, checking history data, quality control test, voice and other function control.',
    method5: "Data Transfer",
    method6:
      "After the device is power on, the device will connect to the server automatically and the test results will automatically transfer to the cloud server.",
    method7: "Data Sharing",
    method8:
      "After the device is successfully connected to the server, the data can be shared according to the actual needs.",
    method9: "Testing Modes",
    method10:
      "The device defaults in Blood Pressure Testing Mode. Press “Blood Sampling” and “Blood Pressure” Button to switch the mode.",
    method11: "Blood Sampling Test",
    method12:
      "The blood sampling testing module needs to be detected by inserting the card in the corresponding detection area according to the test items. It cannot be mixed. The CODE calibration should be corrected before the test. The blood lipids, blood glucose, and uric acid have different blood collection methods. The operation should be strictly in accordance with the requirements. Please read instruction manual carefully before use. Follow the steps of exact blood sampling test mode-CODE calibration instrument-micro blood sampling & test strip card insertion standby-test strip blood sampling & instrument test to complete the blood sample test.",
    method13:
      "Scan the QR code and Bind the device to get the testing results.",
    method14: "Blood Pressure Test",
    method15: "Follow the following steps to test the BP:",
    method16: "1- Connect the cuff to the device",
    method17: "2- Fasten the cuff",
    method18: "3- Select the “blood pressure”mode",
    method19:
      "4- The device will test the blood pressure and results will show on the display",

    faq1: "Abnormal for Blood Lipid Optical Analysis Module",
    faq2:
      "In case there is abnormal for blood lipid optical analysis module, please clean blood lipid module, or clean mirror, or contact the after sale service for repair",
    faq3: "Abnormal for Blood Lipid Test",
    faq4: "Please re-test (do not move the test card during the test)",
    faq5: "Abnormal for Quality Control Test",
    faq6:
      "Please re-test the quality control or contact the after sale service for repair",
    faq7: "Abnormal for Blood Pressure Test",
    faq8:
      "Please make sure the cuff connected the device correctly, or contact the after sale service for repair",
    faq9: "Abnormal for Blood Glucose/Uric Acid CODE Card",
    faq10: "Please re-insert the CODE card or replace the Code card",
    faq11: "Abnormal for Blood Lipid CODE card",
    faq12: "Please re-insert the CODE card or replace the Code card",
    faq13: "Abnormal for Blood Glucose/Uric Acid Test Strips",
    faq14:
      "Please make sure the test strip is not expired or insert the correct test strip",
    faq15: "Abnormal for Blood Glucose/Uric Acid test",
    faq16:
      "Please re-insert the test strip or use a new test strip to test again",
    faq17: "Test Result too High or Too Low",
    faq18: "Please test again or go to hospital for double check",
    faq19:
      "Thermometer and Battery Icon: Super High/Low Temperature, Low Battery",
    faq20:
      "Please operate the device in right environment or charge the device",
    faq21: "Useful Tips:",
    faq22:
      "1) Before taking blood, please clean your fingers with alcohol or water and make sure no skin care products on your hands;",
    faq23:
      "2) After cleaning, please do wait until it is completely dry before piercing your fingers;",
    faq24: "3) Please do wipe off the first drop of blood;",
    faq25:
      "4) Squeeze blood from both sides of the fingers, and try to squeeze more out at one time;",
    faq26:
      "5) The Blood sugar and uric acid strips must suck the blood within 30 seconds;",
    faq27:
      "6) The blood collection tube is based on the siphon principle, no need to pinch the top, it will automatically suck up to 40ul, no more, no less. Please make sure the blood is 40ul, no more and no less, otherwise the measurement will be inaccurate;",
    faq28:
      "7) In case the test strips are just taken out of the refrigerator, please do wait for 30min and then use the strips. Do make sure the test strips are in same temperature level as the device before testing;",
    faq29: "8) Do not touch the siphon area of the test paper;",
    faq30:
      "9) The blood collection tube cannot touch the clear water film on the first layer of the blood lipid card;",
    faq31:
      "10) The blood in the blood collection tube must be dripped into the blood lipid card at one time;",
    faq32:
      "11) When the user has Symptoms like diarrhoea, vomiting or lacks exercises, the test accuracy might be compromised;",
    faq33:
      "12) Please make sure the test strip can be covered in time and the strips do not exposed in air;",

    record1: ["Date", "Week", "Month", "Year"],
    record2: ["Sun", "Mon", "Tue", "Wed", "Thur", "Fri", "Sat"],
    record3: "Blood Pressure Trend",
    record4: "SBP",
    record5: "DBP",
    record6: "Times",
    record7: "Normal",
    record8: "Abnormal",
    record9: "Details",
    record10: "Blood Lipids Trend",
    record11: "Details",
    record12: "Blood Glucose Trend",
    record13: "Details",
    record14: "Uric Acid Trend",
    record15: "Details",
    record16: "No data",
    record17: "FBG",
    record18: "PBG",
    record19: "Abnormal",
    record20: "Abnormal",
    record21: "Abnormal",
    record22: "Abnormal",
    record23: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec"
    ]
  },

  // 成员页
  member: {
    //首页
    index1: "My Group",
    index2: "Health Group",
    index3: "Show All Health Data",
    index4: "Create a New Group",
    index5: "Group Joined",
    index6: "Abnormal Setting",
    index7: "No Groups",
    index8: "No Groups",
    index9: "Information",
    index10:
      "Create a group and Invite your Friends Join via QR Code Scan/WeChat/Mobile/Email",

    //创建群组
    addgroup1: "Group Name",
    addgroup2: "Group Type  ",
    addgroup3: "Enter The Group Name ",
    addgroup4: "Family",
    addgroup5: "Company",
    addgroup6: "Friend",
    addgroup7: "Hospital",
    addgroup8: "School",
    addgroup9: "Confirm",
    addgroup10: "Cancel",
    addgroup11: "Save",
    addgroup12: "Group name already exists",

    //成员列表
    memberlist1: "Member List",
    memberlist2: "",
    memberlist3: "Abnormalities",
    memberlist4: "Normal",
    memberlist5: "Invite New Member",
    memberlist6: "Delete",
    memberlist7: "No members",
    memberlist8: "loading...",
    memberlist9: "Delete and Leave the Group?",
    memberlist10: "Delete Success",
    memberlist11: "Saved Successfully",
    memberlist12: "Edit",
    memberlist13: "Dismiss",
    memberlist14: "Health Stats",
    memberlist15: " Normal",
    memberlist16: " Abnormal",
    memberlist17: "more details",
    memberlist18: "No data for yesterday",
    memberlist19: "yesterday",

    //修改成员
    updatemember1: "Profile",
    updatemember2: "Change",
    updatemember3: "Old Nickname",
    updatemember4: "Change Nickname",

    //健康数据
    healthdata1: "'s Health Data",
    healthdata2: "Health Data",
    healthdata3: "Sun",
    healthdata4: "Mon",
    healthdata5: "Tue",
    healthdata6: "Wed",
    healthdata7: "Thu",
    healthdata8: "Fri",
    healthdata9: "Sat",
    healthdata10: "Heart Rate",
    healthdata11: "Blood Pressure",
    healthdata12: "Systolic ",
    healthdata13: "Diastolic ",
    healthdata14: "Body Temperature change",
    healthdata15: "SpO2",
    healthdata16: "Sleep",
    healthdata17: "Blood Lipids",
    healthdata18: "Cholesterol",
    healthdata19: "Triglyceride",
    healthdata20: "LDL-C",
    healthdata21: "HDL-C",
    healthdata22: "Blood Glucose",
    healthdata23: "Pre-meal",
    healthdata24: "Post-meal ",
    healthdata25: "Uric Acid",
    healthdata26: "Fetal Heart",
    healthdata27: "Steps",
    healthdata28: "Steps",
    healthdata29: "Calories",
    healthdata30: "kcal",
    healthdata31: "Distance",
    healthdata32: "km",
    healthdata33: "Pace",
    healthdata35: "″/KM",
    healthdata36: "′",
    healthdata37: "Generating Health Report",
    healthdata38: "Activity",
    healthdata39: "Abnormal",
    healthdata40: "Unauthorized ",
    healthdata41: "Edit",
    healthdata42: "Delete",
    healthdata43: "Email: ",
    healthdata44: "Phone: ",
    healthdata45: "Confirm to Delete?",

    //邀请成员
    addmember1: "Add a group",
    addmember2: "Care the Health of Your Beloved Ones",
    addmember4:
      "The health community allows you to track the health of your friends and loved ones in real time, no matter how far away.",
    addmember5: "Details",
    addmember6: "Group Members",
    addmember7: "Add",
    addmember8: "Add",
    addmember9: "QR Code",
    addmember10: "WeChat",
    addmember11: "Invite to join the group by scanning the QR code",
    addmember12: "Invite to join the group via WeChat",
    addmember13: "Mobile/Email",
    addmember14: "Join via Mobile/Email",
    addmember15:
      "You can learn about the health status of members by inviting them to join",
    addmember16: "Send an invitation",
    addmember17: "sent",
    addmember18: "Party to be confirmed",
    addmember19: "I have joined",
    addmember20: "Share now",
    addmember21: "save the image",
    addmember22: "I have refused",
    addmember23: "I have quit",


    // 群组二维码
    code1: "Group QR Code",
    code2: "Health Community",
    code3: "The QR code is valid within 5 minutes, please scan on time.",

    //群组邀请
    invide1: "Group invitation",
    invide2: "Health Community",
    invide3: "invited you to join the group...",
    invide4: "Join the Group？",
    invide5:
      "For your data security, please check the group information before joining.",
    invide6:
      "After joining the group, you can authorize the specific member to view your health data",

    //分享健康数据设置
    sethealthdata1: "Health Data Setting",
    sethealthdata2: "Confirm",
    sethealthdata3: "No nickname Set",
    sethealthdata4: "Allow All",
    sethealthdata5: "Nickname Set",
    sethealthdata6: "Save",
    sethealthdata7: "Enter",
    sethealthdata8: "Please upload image format",
    sethealthdata9: "No nickname Set",
    sethealthdata10: "No Profile Set",
    sethealthdata11: "Nickname length is 1-8 characters",

    // 设置数据区间
    setscope1: "Heart Rate Alert",
    setscope2: "Body Temperature Alert",
    setscope3: "Sleep Alert",
    setscope4: "Fetal Heart Rate",
    setscope5: "Fasting Blood Glucose",
    setscope6: "Postprandial Blood Glucose",
    setscope7: "SpO2 Alert",
    setscope8: "Male Uric Acid",
    setscope9: "Female Uric Acid",
    setscope10: "Systolic ",
    setscope11: "Diastolic ",
    setscope12: "High",
    setscope13: "Low",
    setscope14: "Health Alert Setting",
    setscope15: "Set Successfully",
    setscope16: "Too Much",
    setscope17: "Too Little",

    //下载页
    onload1: "Click",
    onload2: "Join Group",
    onload3: "Open with Browser",
    onload4: "Confirm",
    onload5: "Enjoy Health Every Day",
    onload6: "Free Download in App Store",
    onload7: "Free Download in App Store",
    onload8: "Link has expired",
    onload9: "QR code has expired",
    onload10: "Join Successfully",

    // 待处理
    pending1: "Accept",
    pending2: "Decline",
    pending3: "Send Invitation Again",
    pending4: "No Data",
    pending5: "Invitation sent already, please wait for confirm.",
    pending6: "OK",

    guide1: "Please create a new group and name it.",
    guide2:
      "You can check the health data of the group members, and also invite new users to join in the health group.",
    guide3:
      "You can invite new member via QR code scan, wechat, mobile or email. Once the new member joined the group, you can check his/her health status.",
    guide4:
      "You can check the health data history of the group members and know their abnormal data.",
    guide5: "Next",
    guide6: "OK",

    invite1: "Joint via Mobile/Email",
    invite2: "Input the account",
    invite3: "Input the phone No",
    invite4: "Input the email",
    invite5: "Input the correct phone No",
    invite6: "Input the correct email",
    invite7: "Already joined the group",
    invite8: "The user doesn't exist",
    invite9: "Please select a country or region",
    invite10: "Please enter the search keyword",
    invite11: "User",
    invite12: "Invite"
  },

  // 成员页
  JCRing_member: {
    //首页
    index1: "Health Community",
    index2: "Health Group",
    index3: "member",
    index4: "Create a New Group",
    index5: "My Group",
    index6: "Alert Settings",
    index7: "Care The Health of Your Beloved Ones",
    index8: "No Groups",
    index9: "Members",
    index10: "Invite to join via mobile/email/QR code or WeChat",

    //创建群组
    addgroup1: "Group Name",
    addgroup2: "Group Type  ",
    addgroup3: "Please enter",
    addgroup4: "Family Group",
    addgroup5: "Company Group",
    addgroup6: "Other Group",
    addgroup7: "Hospital Group",
    addgroup8: "School Group",
    addgroup9: "Yes",
    addgroup10: "No",
    addgroup11: "Create a New Group",
    addgroup12: "Group name already exists",

    //成员列表
    memberlist1: "Member List",
    memberlist2: "have",
    memberlist3: "Abnormalities",
    memberlist4: "Normal",
    memberlist5: "Add a Member",
    memberlist6: "Delete",
    memberlist7: "No members",
    memberlist8: "loading...",
    memberlist9: "Are you sure to dismiss the group?",
    memberlist10: "Delete Success",
    memberlist11: "Saved Successfully",
    memberlist12: "Edit",
    memberlist13: "Dismiss",
    memberlist14: "Health Stats",
    memberlist15: " Normal",
    memberlist16: " Abnormal",
    memberlist17: "more details",
    memberlist18: "No data for yesterday",
    memberlist19: "yesterday",
    memberlist20: "You just invite",
    memberlist21: "to join the Groupxxx, please confirm!",

    //修改成员
    updatemember1: "Profile",
    updatemember2: "Change",
    updatemember3: "Old Nickname",
    updatemember4: "Change Nickname",

    //健康数据
    healthdata1: " Health",
    healthdata2: "Health Data",
    healthdata3: "Sun",
    healthdata4: "Mon",
    healthdata5: "Tue",
    healthdata6: "Wed",
    healthdata7: "Thu",
    healthdata8: "Fri",
    healthdata9: "Sat",
    healthdata10: "Heart Rate",
    healthdata11: "HRV",
    healthdata12: "Systolic ",
    healthdata13: "Diastolic ",
    healthdata14: "Body Temperature",
    healthdata15: "SpO2",
    healthdata16: "Sleep",
    healthdata17: "Stress",
    healthdata18: "Cholesterol",
    healthdata19: "Triglyceride",
    healthdata20: "LDL-C",
    healthdata21: "HDL-C",
    healthdata22: "Blood Glucose",
    healthdata23: "Pre-meal",
    healthdata24: "Post-meal ",
    healthdata25: "VO2 Max",
    healthdata26: "Respiratory",
    healthdata27: "Steps",
    healthdata28: "Steps",
    healthdata29: "Calories",
    healthdata30: "kcal",
    healthdata31: "Distance",
    healthdata32: "km",
    healthdata33: "Pace",
    healthdata35: "″/KM",
    healthdata36: "′",
    healthdata37: "Generating Health Report",
    healthdata38: "Activity Data",
    healthdata39: "Warning",
    healthdata40: "Unauthorized ",
    healthdata41: "Edit",
    healthdata42: "Delete",
    healthdata43: "Email: ",
    healthdata44: "Phone: ",
    healthdata45: "Confirm to Delete?",
    healthdata46: "Future dates cannot be displayed",
    healthdata47: "Today",


    //邀请成员
    addmember1: "Add a member",
    addmember2: "Add ID",
    addmember4: "You can view your member's health data and adjust his/her abnormal setting.",
    addmember5: "Details",
    addmember6: "Group Members",
    addmember7: "Invite",
    addmember8: " to join",
    addmember9: "QR Code",
    addmember10: "WeChat",
    addmember11: "Invite to join the group by scanning the QR code",
    addmember12: "Invite to join the group via WeChat",
    addmember13: "Mobile/Email",
    addmember14: "Join via Mobile/Email",
    addmember15:
      "Invite your beloved ones to join the group and know their health better.",
    addmember16: "Invite now",
    addmember17: "Already sent ",
    addmember18: "Waiting for confirm",
    addmember19: "JOINED",
    addmember20: "Share now",
    addmember21: "save image",
    addmember22: "Denied ",
    addmember23: "quit",
    addmember24: "Already quit the group",
    addmember25: "Refused to join",
    addmember26: "Already in group",
    addmember27: "Other addition methods", 


    // 群组二维码
    code1: "Group QR Code",
    code2: "Health Community",
    code3: "The QR code is valid within 5 minutes, please scan on time.",

    //群组邀请
    invide1: "Group invitation",
    invide2: "Health Community",
    invide3: "You are invited to join  Group, please confirm!",
    invide4: "Join the Group？",
    invide5:
      "For your data security, please check the group information before joining.",
    invide6:
      "After joining the group, you can authorize the specific member to view your health data",

    //分享健康数据设置
    sethealthdata1: "Health Data Setting",
    sethealthdata2: "Confirm",
    sethealthdata3: "No nickname ",
    sethealthdata4: "Allow All",
    sethealthdata5: "Nickname ",
    sethealthdata6: "Save",
    sethealthdata7: "Enter",
    sethealthdata8: "Please upload image format",
    sethealthdata9: "No nickname ",
    sethealthdata10: "No Profile ",
    sethealthdata11: "Nickname length is 1-8 characters",

    // 设置数据区间
    setscope1: "Heart Rate Alert",
    setscope2: "Body Temperature Alert",
    setscope3: "Sleep Alert",
    setscope4: "Fetal Heart Rate",
    setscope5: "Fasting Blood Glucose",
    setscope6: "Postprandial Blood Glucose",
    setscope7: "SpO2 Alert",
    setscope8: "Male Uric Acid",
    setscope9: "Female Uric Acid",
    setscope10: "Systolic ",
    setscope11: "Diastolic ",
    setscope12: "High",
    setscope13: "Low",
    setscope14: "Alert Setting",
    setscope15: "Set Successfully",
    setscope16: "Too Much",
    setscope17: "Too Little",
    setscope18: " Alert",

    //下载页
    onload1: "Click",
    onload2: "Join Group",
    onload3: "Open with Browser",
    onload4: "Confirm",
    onload5: "Enjoy Health Every Day",
    onload6: "Free Download in App Store",
    onload7: "Free Download in App Store",
    onload8: "Link has expired",
    onload9: "QR code has expired",
    onload10: "Join Successfully",

    // 待处理
    pending1: "Accept",
    pending2: "Decline",
    pending3: "Send Invitation Again",
    pending4: "No Data",
    pending5: "Invitation sent already, please wait for confirm.",
    pending6: "OK",
    pending7: "exit",

    guide1: "Please create a health group and name it.",
    guide2:
      "You can check the health data of the group members and also invite new member to join this health group.",
    guide3:
      "You can invite new members via QR code scan, WeChat, mobile or email. Once the new member joins the group, you can check his/her health data.",
    guide4:
      "You can check the health history of the group members and know their abnormal data",
    guide5: "Next",
    guide6: "OK",
    guide7: "overwarning",

    invite1: "Joint via Mobile/Email",
    invite2: "Input the account",
    invite3: "Input the phone No",
    invite4: "Input the email",
    invite5: "Input the correct phone No",
    invite6: "Input the correct email",
    invite7: "Already joined the group",
    invite8: "The user doesn't exist",
    invite9: "Please select a country or region",
    invite10: "Please enter the search keyword",
    invite11: "User",
    invite12: "Invite",
    invite13: "please select"

  }
};



// WEBPACK FOOTER //
// ./src/lang/en.js